export interface FreelancerProfile {
  id: string;
  ownerId: string;
  displayName: string;
  headline: string;
  bio: string;
  skills: string;
  avatarUrl: string;
  location: string;
  phone: string;
  website: string;
  memberSince: string;
}

export interface FreelancerReview {
  id: string;
  reviewerName: string;
  reviewerInitials: string;
  rating: number;
  comment: string;
  date: string;
}

export const mockFreelancerProfiles: FreelancerProfile[] = [
  {
    id: 'freelancer-matthew-dotse',
    ownerId: 'freelancer-matthew-dotse',
    displayName: 'Matthew DOTSE',
    headline: 'Développeur Web Full-Stack',
    bio: "Développeur passionné basé à Lomé, je conçois des sites vitrines et des applications web modernes, rapides et responsives. Avec plus de 5 ans d'expérience, j'accompagne les entreprises africaines dans leur transformation numérique, de la conception à la mise en ligne.",
    skills: 'React, TypeScript, Tailwind CSS, Node.js, Supabase, SEO',
    avatarUrl: '',
    location: 'Lomé, Togo',
    phone: '+228 90 12 34 56',
    website: 'https://matthewdotse.dev',
    memberSince: '2022',
  },
  {
    id: 'freelancer-creativelab',
    ownerId: 'freelancer-creativelab',
    displayName: 'CreativeLab Studio',
    headline: 'Designer Graphique & Identité visuelle',
    bio: "Studio de design spécialisé dans la création d'identités visuelles mémorables. Nous aidons les marques à se démarquer grâce à des logos originaux, une charte graphique cohérente et des visuels percutants adaptés au marché africain.",
    skills: 'Logo design, Branding, Illustration, Figma, Adobe Illustrator',
    avatarUrl: '',
    location: 'À distance',
    phone: '+228 91 22 33 44',
    website: 'https://creativelab.studio',
    memberSince: '2021',
  },
  {
    id: 'freelancer-wax-digital',
    ownerId: 'freelancer-wax-digital',
    displayName: 'Wax Digital',
    headline: 'Social Media Manager & Stratège de contenu',
    bio: "Agence de marketing digital qui fait grandir votre communauté. Nous définissons des stratégies de contenu sur mesure, créons des visuels engageants et pilotons vos réseaux sociaux pour transformer votre audience en clients fidèles.",
    skills: 'Stratégie de contenu, Community management, Meta Ads, Canva, Analytics',
    avatarUrl: '',
    location: 'Lomé, Togo',
    phone: '+228 92 33 44 55',
    website: 'https://waxdigital.com',
    memberSince: '2021',
  },
  {
    id: 'freelancer-plume-africaine',
    ownerId: 'freelancer-plume-africaine',
    displayName: 'Plume Africaine',
    headline: 'Rédactrice web & Copywriter SEO',
    bio: "Rédactrice passionnée, je transforme vos idées en contenus clairs, engageants et optimisés pour le référencement. Articles de blog, pages de vente ou newsletters, je vous aide à renforcer votre autorité en ligne et à attirer du trafic qualifié.",
    skills: 'Rédaction SEO, Copywriting, Storytelling, WordPress, Recherche de mots-clés',
    avatarUrl: '',
    location: 'À distance',
    phone: '+228 93 44 55 66',
    website: 'https://plumeafricaine.com',
    memberSince: '2023',
  },
  {
    id: 'freelancer-motioncraft',
    ownerId: 'freelancer-motioncraft',
    displayName: 'MotionCraft',
    headline: 'Motion Designer & Monteur vidéo',
    bio: "Je crée des vidéos animées et des montages qui captent l'attention. Du storyboard à l'habillage sonore, je donne vie à vos produits et services avec un rendu professionnel pensé pour les réseaux sociaux et le web.",
    skills: 'After Effects, Premiere Pro, Animation 2D, Storyboard, Motion design',
    avatarUrl: '',
    location: 'À distance',
    phone: '+228 90 55 66 77',
    website: 'https://motioncraft.com',
    memberSince: '2022',
  },
  {
    id: 'freelancer-apeiron',
    ownerId: 'freelancer-apeiron',
    displayName: 'Apeiron Consulting',
    headline: 'Consultant Business & Stratégie',
    bio: "Cabinet de conseil qui accompagne les entrepreneurs et les PME africaines. Business plan, modélisation financière et stratégie de croissance : nous vous aidons à structurer votre projet et à convaincre investisseurs et banques.",
    skills: 'Business plan, Modélisation financière, Étude de marché, Pitch deck, Levée de fonds',
    avatarUrl: '',
    location: 'Lomé, Togo',
    phone: '+228 91 66 77 88',
    website: 'https://apeiron-consulting.com',
    memberSince: '2020',
  },
  {
    id: 'freelancer-insight',
    ownerId: 'freelancer-insight',
    displayName: 'Insight Analytics',
    headline: 'Data Analyst & Visualisation de données',
    bio: "Je transforme vos données brutes en décisions éclairées. Nettoyage, analyse et tableaux de bord interactifs : je vous aide à suivre vos indicateurs clés en temps réel et à révéler les opportunités cachées dans vos données.",
    skills: 'Python, SQL, Power BI, Tableau, Machine Learning',
    avatarUrl: '',
    location: 'À distance',
    phone: '+228 92 77 88 99',
    website: 'https://insight-analytics.com',
    memberSince: '2022',
  },
  {
    id: 'freelancer-beatlab',
    ownerId: 'freelancer-beatlab',
    displayName: 'BeatLab Studio',
    headline: 'Producteur musical & Ingénieur du son',
    bio: "Studio de production musicale à Lomé. De la composition au mastering, je donne à vos morceaux un rendu professionnel prêt à être diffusé sur toutes les plateformes. Un accompagnement créatif de bout en bout selon vos références artistiques.",
    skills: 'Production musicale, Mixage, Mastering, Ableton Live, Logic Pro',
    avatarUrl: '',
    location: 'Lomé, Togo',
    phone: '+228 93 88 99 00',
    website: 'https://beatlab.studio',
    memberSince: '2021',
  },
];

export const mockFreelancerReviews: Record<string, FreelancerReview[]> = {
  'freelancer-matthew-dotse': [
    {
      id: 'rev-m1',
      reviewerName: 'Akou Sossou',
      reviewerInitials: 'AS',
      rating: 5,
      comment:
        "Matthew a livré notre site vitrine en avance et le résultat dépasse nos attentes. Très à l'écoute, réactif et un rendu vraiment professionnel. Je recommande vivement.",
      date: '2026-08-14',
    },
    {
      id: 'rev-m2',
      reviewerName: 'Jean Koffi',
      reviewerInitials: 'JK',
      rating: 5,
      comment:
        'Excellent développeur, code propre et bien commenté. Il a su comprendre nos besoins et proposer de meilleures solutions techniques. Collaboration fluide du début à la fin.',
      date: '2026-07-28',
    },
    {
      id: 'rev-m3',
      reviewerName: 'Fatou Ndiaye',
      reviewerInitials: 'FN',
      rating: 4,
      comment:
        "Très bon travail global. Quelques ajustements mineurs en fin de projet mais Matthew a été réactif pour les corriger. Site rapide et élégant, je suis satisfaite.",
      date: '2026-07-02',
    },
  ],
  'freelancer-creativelab': [
    {
      id: 'rev-c1',
      reviewerName: 'Mariam Diallo',
      reviewerInitials: 'MD',
      rating: 5,
      comment:
        "Notre nouveau logo et notre charte graphique sont superbes. L'équipe a proposé plusieurs concepts créatifs et a su capter exactement l'esprit de notre marque.",
      date: '2026-08-10',
    },
    {
      id: 'rev-c2',
      reviewerName: 'Yao Mensah',
      reviewerInitials: 'YM',
      rating: 5,
      comment:
        'Professionnalisme et créativité au rendez-vous. Livraison rapide, fichiers sources inclus et un accompagnement précieux. Je referai appel à eux sans hésiter.',
      date: '2026-07-15',
    },
  ],
  'freelancer-wax-digital': [
    {
      id: 'rev-w1',
      reviewerName: 'Aïcha Bamba',
      reviewerInitials: 'AB',
      rating: 5,
      comment:
        "Notre communauté a presque doublé en un mois grâce à leur stratégie de contenu. Les visuels sont magnifiques et le reporting mensuel très clair. Super équipe.",
      date: '2026-08-05',
    },
    {
      id: 'rev-w2',
      reviewerName: 'Ibrahim Sanogo',
      reviewerInitials: 'IS',
      rating: 4,
      comment:
        "Très bonne gestion de nos réseaux. Quelques retards ponctuels dans les publications mais le résultat est là : plus d'engagement et de leads qualifiés.",
      date: '2026-07-20',
    },
  ],
  'freelancer-plume-africaine': [
    {
      id: 'rev-p1',
      reviewerName: 'Clarisse Hounkpatin',
      reviewerInitials: 'CH',
      rating: 5,
      comment:
        "Des articles remarquablement bien écrits et parfaitement optimisés. Notre trafic organique a nettement progressé. Une plume talentueuse et très professionnelle.",
      date: '2026-08-02',
    },
    {
      id: 'rev-p2',
      reviewerName: 'Thierry Agbeko',
      reviewerInitials: 'TA',
      rating: 5,
      comment:
        "Contenu original, livré dans les délais et qui reflète parfaitement notre ton de voix. Je recommande Plume Africaine pour tous vos besoins de rédaction.",
      date: '2026-07-08',
    },
  ],
  'freelancer-motioncraft': [
    {
      id: 'rev-v1',
      reviewerName: 'Nadia Kouassi',
      reviewerInitials: 'NK',
      rating: 5,
      comment:
        "La vidéo animée de notre produit est impressionnante, elle a dépassé nos attentes. Un vrai sens du rythme et de l'esthétique. On nous demande régulièrement qui l'a réalisée !",
      date: '2026-08-11',
    },
    {
      id: 'rev-v2',
      reviewerName: 'David Eklu',
      reviewerInitials: 'DE',
      rating: 4,
      comment:
        'Très bon rendu final et un processus créatif agréable. Le projet a pris un peu plus de temps que prévu mais la qualité est au rendez-vous.',
      date: '2026-07-25',
    },
  ],
  'freelancer-apeiron': [
    {
      id: 'rev-a1',
      reviewerName: 'Amara Touré',
      reviewerInitials: 'AT',
      rating: 5,
      comment:
        "Leur business plan et leur modèle financier nous ont permis de lever nos premiers fonds. Un accompagnement stratégique de très haut niveau, je recommande à tout entrepreneur.",
      date: '2026-08-07',
    },
    {
      id: 'rev-a2',
      reviewerName: 'Sylvie Adjovi',
      reviewerInitials: 'SA',
      rating: 5,
      comment:
        "Analyse rigoureuse et conseils avisés. Le pitch deck était impeccable et nous a ouvert des portes. Merci pour ce professionnalisme.",
      date: '2026-07-18',
    },
  ],
  'freelancer-insight': [
    {
      id: 'rev-i1',
      reviewerName: 'Moussa Traoré',
      reviewerInitials: 'MT',
      rating: 5,
      comment:
        "Le tableau de bord interactif a transformé notre pilotage d'activité. Données nettoyées et visualisations claires. Un excellent investissement.",
      date: '2026-08-09',
    },
    {
      id: 'rev-i2',
      reviewerName: 'Grace Kouamé',
      reviewerInitials: 'GK',
      rating: 5,
      comment:
        "Une analyse approfondie qui a révélé des tendances que nous ne voyions pas. Rapport détaillé et documentation très utile. Je recommande.",
      date: '2026-07-12',
    },
  ],
  'freelancer-beatlab': [
    {
      id: 'rev-b1',
      reviewerName: 'Kojo Amavi',
      reviewerInitials: 'KA',
      rating: 5,
      comment:
        "Mon single est sorti avec un son professionnel et un mixage impeccable. BeatLab a vraiment capté ma vision artistique. Un studio au top.",
      date: '2026-08-13',
    },
    {
      id: 'rev-b2',
      reviewerName: 'Elodie Agbovon',
      reviewerInitials: 'EA',
      rating: 4,
      comment:
        "Très bonne qualité de mastering, mon morceau sonne enfin comme il faut sur toutes les plateformes. Délai un peu long mais le résultat en vaut la peine.",
      date: '2026-07-30',
    },
  ],
};